<template>
  <div class="CopyrightNotice">
    <div class="switch-row flex a-c j-s">
      <div class="switch-title">前台显示</div>
      <div class="flex a-c">
        <el-switch
            @change="confirm"
            :active-value="1"
            :inactive-value="0"
            v-model="state.params.copyrightNoticeFlag"
            :before-change="beforeChange"
            active-color="#2054D6"
            size="large"
        />
        <div class="expand-toggle flex a-c" @click="noticeExpanded = !noticeExpanded">
          <span>{{ noticeExpanded ? '收起' : '展开' }}</span>
          <el-icon><ArrowUp v-if="noticeExpanded" /><ArrowDown v-else /></el-icon>
        </div>
      </div>
    </div>
    <div class="switch-tip">该设置为控制数据库导航功能页面中的版权公告是否显示</div>

    <div class="label-title">中文版</div>
    <div>
      <div class="editor-collapse-wrap" :class="noticeExpanded ? 'expanded' : 'collapsed'">
        <tinyMceEditor ref="cnContentRef" :defaultId="'cnContentRef'" key="cnContentRef"
          @update:modelValue="(val) => updateContent(val, 1) " />
      </div>
    </div>

    <div class="label-title">英文版</div>
    <div>
      <div class="editor-collapse-wrap" :class="noticeExpanded ? 'expanded' : 'collapsed'">
        <tinyMceEditor ref="enContentRef" :defaultId="'enContentRef'" key="enContentRef"
          @update:modelValue="(val) => updateContent(val, 2) " />
      </div>
    </div>

    <div class="button-container flex a-c j-c" style="margin-top: 20px">
      <el-button color="#626aef" @click="submit">保存</el-button>
      <el-button color="#626aef" plain @click="reset">重置</el-button>
    </div>
  </div>
</template>

<script>
import {
  findOneUnifyNoticeBySid, saveManagerDatabaseDetailsBaseInfo,
  updateUnifyNoticeBySid,
  findOneGlobalSettingBySid, updateSystemGlobalSettingBySid
} from "@/js/network/main"

import tinyMceEditor from "@/components/untils/tinyMceEditor"
import {onMounted, reactive, ref} from "vue";
import {useRoute} from "vue-router";
import {MessageBox} from "@/js/utils/commonJs";
import {ElMessageBox} from "element-plus";

export default {
  name:'CopyrightNotice',
  components: {
    tinyMceEditor
  },

  setup(props, {attrs, slots, emit, expose}) {
    const route = useRoute();

    let cnState = ref("");
    let enState = ref("");
    let cnStateCopy = "";
    let enStateCopy = "";


    let cnContentRef = ref(null);
    let enContentRef = ref(null);

    // 中英文公告富文本默认收起
    let noticeExpanded = ref(false);

    // 前台显示开关（与全局设置共用字段）
    let isFirst = ref(true);
    let state = reactive({
      params: {},
    });

    const confirm = () => {
      if(isFirst.value){
        return;
      }
      // 开关打开时展开公告编辑器；关闭时收起
      if(state.params.copyrightNoticeFlag == 1){
        noticeExpanded.value = true;
      } else {
        noticeExpanded.value = false;
      }
      updateSystemGlobalSettingBySid(state.params).then(res => {
        if (!res.success) {
          MessageBox.error(res.msg);
          return;
        }
        MessageBox.success("操作成功！");
      }).catch(error => {
        console.log(error,"catchError");
      });
    }
    const beforeChange = function () {
      isFirst.value = false;
      return new Promise((resolve, reject) => {
        ElMessageBox.confirm('确定要执行本操作吗?').then((aaa) => {
          if (aaa) {
            resolve(true);
          }
          reject(false);
        }).catch(() => {
          reject(false);
        })
      })
    }
    const initSetting = function () {
      findOneGlobalSettingBySid().then(res => {
        if (!res.success) {
          MessageBox.error(res.msg);
          return;
        }
        if(!res || !res.data){
          return;
        }
        state.params = res.data;
        // 回显开关为开启状态时，公告编辑器默认展开
        noticeExpanded.value = res.data.copyrightNoticeFlag == 1;
      }).catch(error => {
        console.log(error,"catchError");
      });
    }


    const updateContent = (val , type) => {
      if(type == 1){
        cnState.value = val;
      }

      if(type == 2){
        enState.value = val;
      }
    }
    const init = function () {
      // let {id}
      findOneUnifyNoticeBySid(1).then(res => {
        if (!res.success) {
          MessageBox.error(res.msg);
          return;
        }
        if(!res || !res.data){
          return;
        }
        cnState.value = res.data.content;
        enState.value = res.data.enContent;
        cnStateCopy = res.data.content;
        enStateCopy = res.data.enContent;
        cnContentRef.value.handleSetContent(cnState.value);
        enContentRef.value.handleSetContent(enState.value);
      }).catch(error => {
        //MessageBox.error(error);
        console.log(error,"catchError");
      });
    }
    const submit = () => {
      ElMessageBox.confirm('确定要执行本操作吗?').then((aaa) => {
        if (aaa) {
          let params ={
            type: 1,
            content:cnState.value,
            enContent:enState.value
          }
          updateUnifyNoticeBySid(params).then(res => {
            if (!res.success) {
              MessageBox.error(res.msg);
              return;
            }
            MessageBox.success("保存成功！")
          }).catch(error => {
            //MessageBox.error(error);
            console.log(error,"catchError");
          });
        }
      }).catch(() => {
      })

    }
    const reset = () => {
      cnState.value = cnStateCopy;
      enState.value = enStateCopy;
      cnContentRef.value.init(cnState.value);
      enContentRef.value.init(enState.value);
    }
    onMounted(()=>{
      setTimeout(()=>{
        init();
      },400)

    })
    initSetting();

    return {
      updateContent,
      cnContentRef,
      enContentRef,
      submit,
      reset,
      noticeExpanded,
      state,
      confirm,
      beforeChange
    }


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.CopyrightNotice{
  height: calc(100vh - 180px);
  overflow-y: scroll;
  // pedestal 70    padding-top 20   padding-bottom 20  navlist  40   footer  30
}

.label-title{
  padding: 20px 0 12px 0;
  font-weight: 600;
}

.switch-row{
  padding: 4px 0 8px 0;

  .switch-title{
    color: #2B3348;
    font-size: 16px;
    font-weight: 600;
  }

  .expand-toggle{
    margin-left: 16px;
  }
}

.switch-tip{
  color: #6573A2;
  font-size: 14px;
  margin-bottom: 0;
}

.editor-collapse-wrap{
  &.collapsed{
    max-height: 0;
    overflow: hidden;
  }
}

.expand-toggle{
  padding: 6px 0;
  font-size: 13px;
  color: #257dd9;
  cursor: pointer;
  user-select: none;
  gap: 4px;
}

</style>
